export default function isTeamAssistV2Enabled(appFeatures) {
  return (
    Boolean(appFeatures) &&
    appFeatures.isEnabled('teamAssistAI') &&
    appFeatures.isEnabled('conversation:general') &&
    appFeatures.isEnabled('teamAssistV2')
  );
}
